export default __webpack_public_path__ + "static/media/product-image-3.dd927d89.png";